"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FormattedUnit = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _convertUnit = require("./convert-unit");

var _index = require("./index");

var _metricToImperial = _interopRequireDefault(require("./metric-to-imperial"));

var _unitSuffix = _interopRequireDefault(require("./unitSuffix"));

var _excluded = ["from", "to", "hideUnit", "value", "children", "tagName", "intl", "roundValue"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormattedUnit = function FormattedUnit(_ref) {
  var from = _ref.from,
      to = _ref.to,
      hideUnit = _ref.hideUnit,
      value = _ref.value,
      children = _ref.children,
      Text = _ref.tagName,
      intl = _ref.intl,
      roundValue = _ref.roundValue,
      other = _objectWithoutProperties(_ref, _excluded);

  var outputUnit = from;
  var convertedValue = value;

  if (to) {
    outputUnit = (0, _convertUnit.mapUnitByMeasurementSystem)(from)(to);
    convertedValue = (0, _index.convertFrom)(from)(outputUnit)(value);
  } // Added roundValue to round the value
  // This changes is specific to celsius to fahrenheit conversion
  // This is a temporary change and will be removed once we have a better solution
  // Currently this roundValue only applied for set point values


  if (roundValue && from === 'degC' && to === 'degF') {
    convertedValue = Math.round(convertedValue);
  }

  var formattedValue = intl.formatNumber(convertedValue, other);

  if (typeof children === 'function') {
    return children({
      value: formattedValue,
      unit: _unitSuffix["default"][outputUnit]
    });
  }

  return /*#__PURE__*/_react["default"].createElement(Text, null, formattedValue, hideUnit ? null : " ".concat(_unitSuffix["default"][outputUnit]));
};

exports.FormattedUnit = FormattedUnit;

var _default = (0, _nicbaseTranslation.injectIntl)(FormattedUnit);

exports["default"] = _default;
var allowedUnits = Object.keys(_metricToImperial["default"]).concat(Object.keys(_metricToImperial["default"]).map(function (key) {
  return _metricToImperial["default"][key];
}));
FormattedUnit.propTypes = {
  intl: _nicbaseTranslation.intlShape.isRequired,
  children: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
  value: _propTypes["default"].number.isRequired,
  from: _propTypes["default"].oneOf(allowedUnits).isRequired,
  to: _propTypes["default"].oneOf(['METRIC', 'IMPERIAL'].concat(allowedUnits)),
  hideUnit: _propTypes["default"].bool,
  tagName: _propTypes["default"].string,
  minimumFractionDigits: _propTypes["default"].number,
  maximumFractionDigits: _propTypes["default"].number,
  roundValue: _propTypes["default"].bool
};
FormattedUnit.defaultProps = {
  children: null,
  tagName: 'span',
  hideUnit: false,
  to: null,
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
  roundValue: false
};